import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.FORNECEDOR_ITEM_ATA.BUSCAR_FORNECEDOR_PRINCIPAL_COM_ADERENTES]({ state }) {
		const { idItemBuscarFornecedores } = state
		const { data } = await api.fornecedorItemAta.buscarFornecedorPrincipalComAderentes(idItemBuscarFornecedores)
		return data
	},
}
